<template>
  <div class="message">
    <el-input v-model="filter.notice" placeholder="请输入"></el-input>
    <el-button style="margin-top: 20px" type="primary" size="small" @click="updateNotice">修改</el-button>
  </div>
</template>

<script>
import { getNotice, updateNotice } from '@/api/season/vip.js'
export default {
  name: 'message',
  data () {
    return {
      filter: {
        id: 1,
        notice: ''
      }
    }
  },
  created() {
    this.getNotice()
  },
  methods: {
    async getNotice() {
      const res = await getNotice()
      this.filter = res.data
    },
    async updateNotice() {
      const res = await updateNotice(this.filter)
      this.$message.success('修改成功!')
      this.getNotice()
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
